import React, { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet';
import { injectIntl } from 'react-intl';
import { useSelector } from 'react-redux';
import moment from 'moment';
import Authorize from 'components/Providers/Authorize';
import PageWrapper from 'components/Shared/Page/Wrapper';
import PageTitle from 'components/Shared/Page/Title';
import withPusher from 'components/Providers/Pusher/withPusher';
import PageBanners from 'components/Layout/PageBanners';
import { EmptyIconLarge } from 'components/Shared/Icons';
import useTranslation from 'utils/hooks/useTranslation';
import { AMPLITUDE_EVENT_TYPES } from 'constants/amplitude';
import useAmplitude from '../../utils/hooks/useAmplitude';
import useSalesforceInvoicesPage from './useSalesforceInvoicesPage';
import TableControl from '../InvoicesAndStatements/TableControl';
import SalesforceInvoicesTable from './SalesforceInvoicesTable';
import styles from './style.module.scss';
import { formatSalesforceInvoicesSummaryList } from './helper';

const SalesforceInvoices = ({ history }) => {
  const { translateText } = useTranslation();
  const { sendAmplitudeEvent } = useAmplitude();

  const isSalesforceEnabled = useSelector(
    state => state.user.currentCorporation?.isSalesforceEnabled,
  );

  const [selectedDateRange, setSelectedDateRange] = useState(
    isSalesforceEnabled
      ? {
          startDate: moment()
            .startOf('year')
            .format('YYYY-MM-DD'),
          endDate: moment()
            .endOf('year')
            .format('YYYY-MM-DD'),
        }
      : {},
  );

  const {
    salesforceInvoicesSummaryList,
    isSalesforceInvoiceSummaryListSuccess,
    isSalesforceInvoiceSummaryListError,
    handleDownloadPdf,
  } = useSalesforceInvoicesPage({
    timeFrame: selectedDateRange,
  });

  useEffect(() => {
    sendAmplitudeEvent(AMPLITUDE_EVENT_TYPES.salesforceInvoicesPageViewed);
  }, [sendAmplitudeEvent]);

  return (
    <Authorize>
      <Helmet title="Invoices" />
      <PageBanners />
      <PageWrapper history={history} loading={false}>
        <PageTitle title={translateText('corporateAccounts.menuLeft.invoices')} />
        <div className="card-body">
          <div className={styles.main}>
            <TableControl
              setSelectedDateRange={setSelectedDateRange}
              defaultRange={isSalesforceEnabled ? 'year' : undefined}
              defaultDate={isSalesforceEnabled ? moment() : undefined}
              disabled={!isSalesforceEnabled}
            />
            {isSalesforceEnabled ? (
              <SalesforceInvoicesTable
                handleInvoiceDownload={handleDownloadPdf}
                tableData={formatSalesforceInvoicesSummaryList(salesforceInvoicesSummaryList)}
                selectedDateRange={selectedDateRange}
                isSalesforceInvoiceSummaryListSuccess={isSalesforceInvoiceSummaryListSuccess}
                isSalesforceInvoiceSummaryListError={isSalesforceInvoiceSummaryListError}
              />
            ) : (
              <div className={styles.emptyState}>
                <EmptyIconLarge />
                {translateText('corporateAccounts.invoices.notAvailable')}
              </div>
            )}
          </div>
        </div>
      </PageWrapper>
    </Authorize>
  );
};

export default withPusher(injectIntl(SalesforceInvoices));
